import { Breadcrumbs } from '@components';
import { useScreenSize, useScrollToTop } from '@hooks';
import image3 from '@pngs/AboutUsPage/img3.png';
import Camo from '@pngs/Camo.png';
import Compass from '@pngs/Compass.png';
import { Flex, Image } from '@styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { aboutUsLayoutByVariant } from './AboutUsPage.layoutProps';
import { Banner, OurMissionVision, TextWithPic } from './components';

const AboutUsPage = () => {
  const { i18n } = useTranslation();
  const { device, dynamicWidth, isTabletLG, isTabletSM } = useScreenSize();
  const layout = aboutUsLayoutByVariant[device];

  useScrollToTop();

  return (
    <Flex flexDirection="column">
      <Breadcrumbs containerProps={{ px: layout?.px }} />
      <Banner dynamicWidth={dynamicWidth} layout={layout} />
      <OurMissionVision />
      <Flex backgroundImage={Camo} backgroundSize="contain" position="relative">
        <TextWithPic
          description={i18n.t('AboutUs.Founders.Description')}
          founders
          isTablet={isTabletLG}
          src={image3}
          style={{
            flexDirection: isTabletSM ? 'column' : 'row',
            height: isTabletLG ? 'auto' : '740px',
            marginBottom: isTabletLG ? 0 : '140px',
            pl: !isTabletSM ? layout : 0,
          }}
          title={i18n.t('AboutUs.Founders.Title')}
          withBg
        />
      </Flex>
      <Flex
        pb={44}
        pl={layout?.px}
        position="relative"
        pt={isTabletLG ? 80 : 150}
      >
        <Image
          alt="compass"
          height={isTabletLG ? 190 : 250}
          left="0"
          position="absolute"
          src={Compass}
          style={{
            transform: isTabletLG
              ? 'translate(-50%, -40%)'
              : 'translate(0%, -25%)',
            zIndex: 5,
          }}
          top="0"
          width={isTabletLG ? 190 : 250}
        />
        {/* {ambassadors && (
          <Carousel
            containerProps={{
              title: {
                height: isTabletLG ? 84 : 129,
                variant: isTabletLG ? 'BN-bold-s80-lh84' : 'BN-bold-s123-lh104',
              },
            }}
            description={i18n.t('AboutUs.Ambassadors.Description')}
            infinite
            items={ambassadors}
            renderItem={(item) => (
              <AmbassadorCard
                key={item?.id}
                description={item?.description}
                image={item?.image}
                itemClass="ambassador-card-class"
                title={item?.title}
              />
            )}
            title={i18n.t('AboutUs.Ambassadors.Title')}
            withButtons={!isTabletLG}
          />
        )} */}
      </Flex>
    </Flex>
  );
};

export default AboutUsPage;
